module.exports = "/_next/static/files/4f135e13a5fdf637fea059c45b81d759.svg";